"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _PaymasterApi_apiClient;
Object.defineProperty(exports, "__esModule", { value: true });
exports.sponsorUserOperation = exports.PaymasterApi = void 0;
const axios_1 = __importStar(require("axios"));
const Configuration_1 = require("../Configuration");
const Error_1 = require("../Error");
class PaymasterApi {
    constructor(apiClient) {
        _PaymasterApi_apiClient.set(this, void 0);
        this.create = async (data) => {
            const organizationId = await __classPrivateFieldGet(this, _PaymasterApi_apiClient, "f").currentOrganization();
            const response = await __classPrivateFieldGet(this, _PaymasterApi_apiClient, "f").post(`/v1/organizations/${organizationId}/endpoints`, { data, baseURL: Configuration_1.Configuration.paymasterApiUrl });
            if (response.ok) {
                return this.createResponse(response.data);
            }
            throw new Error_1.KriptonioError({
                message: `error while creating paymaster endpoint. ${response.error.stringify()}`,
            });
        };
        this.get = async (props) => {
            const response = await __classPrivateFieldGet(this, _PaymasterApi_apiClient, "f").get(`/v1/endpoints/${props.id}`, { baseURL: Configuration_1.Configuration.paymasterApiUrl });
            if (response.ok) {
                return this.createResponse(response.data);
            }
            throw new Error_1.KriptonioError({
                message: `error while getting paymaster endpoint. ${response.error.stringify()}`,
            });
        };
        this.getOrCreate = async (props) => {
            const response = await __classPrivateFieldGet(this, _PaymasterApi_apiClient, "f").get(`/v1/organizations/${props.organizationId}/endpoints/chains/${props.chainId}?entryPoint=${props.entryPoint}&${props.wallet ? `wallet=${props.wallet}` : ''}`, { baseURL: Configuration_1.Configuration.paymasterApiUrl });
            if (response.ok) {
                return this.createResponse(response.data);
            }
            throw new Error_1.KriptonioError({
                message: `error while getting paymaster endpoint. ${response.error.stringify()}`,
            });
        };
        this.createResponse = (response) => {
            return {
                id: response.id,
                title: response.title,
                wallet: response.wallet?.toString(),
                chainId: response.paymaster.chainId,
                url: `${Configuration_1.Configuration.paymasterApiUrl}/v1/endpoints/${response.accessToken}/sponsor`,
            };
        };
        __classPrivateFieldSet(this, _PaymasterApi_apiClient, apiClient, "f");
    }
}
exports.PaymasterApi = PaymasterApi;
_PaymasterApi_apiClient = new WeakMap();
async function sponsorUserOperation(paymasterUrl, userOperation, entryPoint) {
    try {
        const body = { userOperation, entryPoint };
        const response = await axios_1.default.post(paymasterUrl, body, {
            timeout: 100000,
            headers: {
                'Content-Type': 'application/json',
            },
        });
        return {
            paymasterAndData: response.data.paymasterAndData,
            preVerificationGas: response.data.preVerificationGas,
            verificationGasLimit: response.data.verificationGasLimit,
            callGasLimit: response.data.callGasLimit,
        };
    }
    catch (error) {
        if (error instanceof axios_1.AxiosError) {
            const axiosError = error;
            if (!axiosError.response?.data) {
                throw error;
            }
            throw new Error_1.KriptonioError(axiosError.response.data);
        }
        throw error;
    }
}
exports.sponsorUserOperation = sponsorUserOperation;
